"use client";
import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
const COMPONENT_NAME = "AddToListProviderClient";
const AddToListProviderContext = createContext(null);
const AddToListProviderClient = (props) => {
  const { contentStackValues, children, enableModernApis } = props;
  return /* @__PURE__ */ jsx(
    AddToListProviderContext.Provider,
    {
      value: {
        contentStackValues,
        enableModernApis
      },
      children
    }
  );
};
AddToListProviderClient.displayName = COMPONENT_NAME;
export {
  AddToListProviderClient,
  AddToListProviderContext
};
